/*
 * @Author: Teemo Ding
 * @Date: 2021-09-14 17:21:56
 * @LastEditTime: 2022-06-10 14:21:37
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelDomain/List/config.tsx
 */
import { Form, Select } from '@/src/components/Antd';
import {
  MissingPageRedirectType,
  MissingPageType,
} from '@/src/types/common/domain';
import React, { useMemo } from 'react';
import css from '../css.module.less';
const { Item } = Form;

const missingPageTypeOption = (missingPageType) => [
  {
    label: 'Maintenance Page',
    value: MissingPageRedirectType.MaintenancePage,
  },
  {
    label: 'Other Page',
    value: MissingPageRedirectType.OtherPage,
  },
];

export enum ActionType {
  Edit = 'Edit',
  Connect = 'Connect',
  Delete = 'Delete',
}

const TableDefultValue = ({ value, getI18n }: any) => {
  const name = {
    [MissingPageType.NoAvailableContentVersion]: getI18n(
      'salesChannelMiniProgramSettings.index.noAvailableContentVersion',
    ),
    [MissingPageType.PageDeleted]: getI18n(
      'salesChannelMiniProgramSettings.index.pageDeleted',
    ),
    [MissingPageType.PageExpired]: getI18n(
      'salesChannelMiniProgramSettings.index.pageExpired',
    ),
    [MissingPageType.ProductDeleted]: getI18n(
      'salesChannelMiniProgramSettings.index.productDeleted',
    ),
  };
  return name[value];
};

const RenderSelect = ({
  value,
  onChange,
  missingPageOnChange,
  index,
  edit,
  missingPageType,
  getI18n,
}: // linkListData,
any) => {
  const handleMissingPageOnCahnge = (selectValue) => {
    //
    if (selectValue == MissingPageRedirectType.OtherPage) {
      missingPageOnChange(selectValue, value, index);
    } else {
      onChange({ ...value, missingPageRedirectType: selectValue });
    }
  };

  const selectValue = useMemo(() => {
    if (value.missingPageRedirectType == MissingPageRedirectType.OtherPage) {
      const linkModule = value.linkModule;
      return linkModule.label || '';
    } else {
      return value.missingPageRedirectType;
    }
  }, [value]);
  const optionsList = missingPageTypeOption({ getI18n });
  const _selectValue = optionsList.find((item) => item.value === selectValue);
  return edit ? (
    <Select
      value={selectValue}
      onChange={handleMissingPageOnCahnge}
      className={css.missingPageRedirectType}
      optionsList={optionsList}
    />
  ) : (
    <div>{_selectValue ? _selectValue.label : selectValue}</div>
  );
};

export const redirectColumns = (
  fields,
  missingPageOnChange,
  edit,
  form,
  { getI18n },
) =>
  // linkListData,
  [
    {
      title: getI18n('salesChannelMiniProgramSettings.index.missingPageType'),
      dataIndex: 'missingPageType',
      key: 'missingPageType',
      default: true,
      optional: false,
      className: css.columnClass,
      minWidth: 448,
      childGenerate: (text, record, index) => {
        return (
          <Item
            className={css.missingPageType}
            name={[fields[index].name, 'missingPageType']}>
            <TableDefultValue getI18n={getI18n} />
          </Item>
        );
      },
    },
    {
      title: getI18n('salesChannelMiniProgramSettings.index.redirectto'),
      dataIndex: 'missingPageRedirectType',
      key: 'missingPageRedirectType',
      default: true,
      optional: false,
      className: css.columnClass,
      minWidth: 640,
      childGenerate: (text, record, index) => {
        return (
          <Item className={css.missingPageType} name={[fields[index].name]}>
            <RenderSelect
              missingPageOnChange={missingPageOnChange}
              // linkListData={linkListData}
              edit={edit}
              missingPageType={form.getFieldValue([
                'missingPageRedirections',
                fields[index].name,
                'missingPageType',
              ])}
              index={index}
              getI18n={getI18n}
            />
          </Item>
        );
      },
    },
  ];
